import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

const base = (state: RootState) => state.hackathon;

export const selectHackathonProjectsList = createSelector(base, (state) => ({
  items: state.items,
  meta: state.meta,
  query: state.query,
  loading: state.loading,
  error: state.error
}));

export const selectHackathonProjectsItems = (state: RootState) => state.hackathon.items;
export const selectHackathonProjectsMeta = (state: RootState) => state.hackathon.meta;
export const selectHackathonProjectsQuery = (state: RootState) => state.hackathon.query;
export const selectHackathonProjectsLoading = (state: RootState) => state.hackathon.loading;
export const selectHackathonProjectsError = (state: RootState) => state.hackathon.error;

export const selectCurrentProject = createSelector(base, (state) => ({
  project: state.currentProject,
  loading: state.currentProjectLoading,
  error: state.currentProjectError
}));

export const selectProjectByDocumentId = (documentId: string) =>
  createSelector(
    (state: RootState) => state.hackathon.items,
    (items) => items.find((item) => item.documentId === documentId)
  );

export const selectVoteRanking = (state: RootState) => state.hackathon.voteRanking;
export const selectVoteRankingLoading = (state: RootState) => state.hackathon.voteRankingLoading;
export const selectVoteRankingError = (state: RootState) => state.hackathon.voteRankingError;
